import React from "react";
import { Container, Accordion, Row, Col } from "react-bootstrap";

const faqData = [
    {
        question: "What is Bed Space?",
        answer:
            "Bed Space is a real estate company that specializes in providing affordable and comfortable shared living spaces and rental properties tailored to meet the needs of individuals, students, and working professionals."
    },
    {
        question: "What services does Bed Space offer?",
        answer:
            "Bed Space offers a variety of real estate services, including: \n- Shared living accommodations. \n- Fully furnished rental properties. \n- Property management services for landlords. \n- Assistance with short-term and long-term rentals."
    },
    {
        question: "Where are your properties located?",
        answer: "Our properties are located in prime areas across [City/Region], focusing on accessibility, convenience, and proximity to schools, workplaces, and public transportation."
    },
    {
        question: "Who can rent a Bed Space property?",
        answer:
            "Our properties are open to anyone looking for affordable housing, including students, young professionals, and individuals seeking short-term or long-term accommodations."
    },
    {
        question: "What is included in a typical Bed Space rental?",
        answer:
            "Most of our rentals include: \n- Fully furnished rooms. \n- Shared kitchen and bathroom facilities. \n- Utilities such as Wi-Fi, electricity, and water (in some cases). \n- Maintenance and cleaning services for common areas."
    },
    {
        question: "Do I need to pay a security deposit?",
        answer:
            "Yes, a refundable security deposit is required. The amount varies based on the property and the duration of your stay."
    },
    {
        question: "How can landlords partner with Bed Space?",
        answer:
            "Landlords can partner with us by listing their properties on our platform. We help find tenants, manage rental agreements, and handle maintenance to maximize your returns."
    },
    {
        question: "What are the benefits of working with Bed Space?",
        answer:
            "Some of the benefits include: \n- Hassle-free property management. \n- Guaranteed rent collection on time. \n- Access to a large pool of potential tenants. \n- Maintenance and tenant support services."
    },
    {
        question: "Do you offer accommodations for students?",
        answer:
            "Yes, we specialize in providing safe, affordable, and convenient housing for students near universities and colleges."
    },
    {
        question: "What makes Bed Space unique in the real estate market?",
        answer:
            "Bed Space stands out because of our focus on affordable shared living, transparency in pricing, and high-quality property management services. We aim to create a hassle-free rental experience for both tenants and landlords."
    }
];

const FAQs = () => {
    return (
        <Container className="mt-5">
            <div className="faq-section">
                <h2 className="text-center my-4">Frequently Asked Questions</h2>
                <Accordion defaultActiveKey="0">
                    <Row className="g-3">
                        {faqData.map((faq, index) => (
                            <Col lg={6} className="mb-2 bg-white rounded">
                                <Accordion.Item eventKey={String(index)} key={index} className="w-100 shadow-sm">
                                    <Accordion.Header>
                                        <h5>{faq.question}</h5>
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        {faq.answer}
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Col>
                        ))}
                    </Row>
                </Accordion>
            </div>
        </Container>
    );
}

export default FAQs;
